


const MetricChart = (props) => {

  const { metric } = props;

  const { policies } = metric; 

  const blocks = []

  let i = 0; 
  let lastEnd = 0;
  while (i < policies.length) {
    const p = policies[i];
    const isPositive = p.impact > 0;
    const before = lastEnd;
    const after = lastEnd + p.impact;
    const block = {
      columnHoverColor: p.description ? 'hover:bg-blue-50' : '',
      bgColor: 'bg-darkblue',
      hoverbgColor: p.description ? 'hover:bg-darkblue' : '',
      textColor: 'text-darkblue',
      hoverTextColor: p.description ? 'hover:text-darkblue' : '',
      top: isPositive ? after : before,
      bottom: isPositive ? before : after,
      tooltipText: p.description,
      tooltipColor: 'bg-blue-50',
      textAbove: p.chartName,
      textBelow: (metric.policyUnitIsCurrency ? '$' : '') + p.impact.toLocaleString() + ' ' + metric.policyUnit,
    }
    lastEnd = after;
    blocks.push(block)
    i++;
  }

  blocks.push({
    columnHoverColor: metric.summaryBlockTooltip ? 'hover:bg-red-50' : '',
    bgColor: 'bg-boldred',
    hoverbgColor: metric.summaryBlockTooltip ? 'hover:bg-boldred' : '',
    textColor: 'text-red-50',
    hoverTextColor: metric.summaryBlockTooltip ? 'hover:text-white' : '',
    bottom: 0, 
    top: lastEnd,
    tooltipText: metric.summaryBlockTooltip,
    tooltipTextColor: 'boldred',
    tooltipColor: 'bg-red-50',
    textAbove: 'total impact',
    blockText: (metric.policyUnitIsCurrency ? '$' : '') + lastEnd.toLocaleString() + ' ' + metric.policyUnit,
  })

  const max = Math.max(blocks[0].top, blocks[blocks.length - 1].top)
  const chartTop = max * 1.2;

  /**
   * Important to keep the class names in full or else postcss removes it
   */
  const colsClass = {
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
    5: 'grid-cols-5',
    6: 'grid-cols-6',
    7: 'grid-cols-7',
    8: 'grid-cols-8',
  }

  return (
    <div className="bg-gray-50 h-96 rounded">
      <div className={`grid ${colsClass[blocks.length]} px-2 gap-2 h-full`}>
        {blocks.map((block, index) => {

          const { bottom, top, bgColor, hoverbgColor, textColor, hoverTextColor, blockText, tooltipText, tooltipColor, tooltipTextColor, columnHoverColor } = block;
          const topF = (1 - (top / chartTop)) * 100;
          const bottomF = bottom / chartTop * 100;

          return (
            <div key={index} className={`has-tooltip h-full flex-grow flex flex-col justify-start items-stretch relative ${columnHoverColor}`}>
              {tooltipText && 
                <div className={`tooltip transform -translate-x-1/3 -translate-y-full text-center`} style={{ width: '300%'}}>
                  <div className={`${tooltipColor} ${tooltipTextColor || textColor} shadow rounded-xl p-8 whitespace-wrap`}>
                   {tooltipText}
                  </div>
                  <div className={`${textColor} flex justify-center`}>
                    <svg className="h-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div>
              }

              <div className="flex flex-col justify-end items-center" style={{ flexBasis: `${topF}%`}}>
                <div className="text-xs font-medium my-1">{block.textAbove}</div>
              </div>
              <div className={`${bgColor} ${hoverbgColor} rounded relative`} style={{ flexBasis: `${100 - topF - bottomF}%` }}>
                <div className={`h-full flex justify-center items-center ${textColor} ${hoverTextColor} font-bold text-center`}>
                  {blockText}
                </div>
              </div>
              <div className="relative" style={{ flexBasis: `${bottomF}%` }}>
                {block.textBelow && <div className="text-xs font-medium my-1 absolute top-0 text-center left-0 right-0">{block.textBelow}</div>}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default MetricChart;